export default "__VITE_ASSET__BJclGnwa__"